module.exports = function getResource(label, vars = []) {
    let resources = {
        item: 'ARTICLE',
        items: 'articles',
        qty: 'QTÉ',
        basketTotal: 'Total du panier',
        subTotal: 'Sous-total',
        checkout: 'Passer à la caisse',
        continue: 'Continuer à magasiner',
        seeSamples: 'Voir les échantillons, récompenses et promotions dans le',
        basket: 'panier',
        title: 'Ajouté au panier',
        reserveTitle: `Ajouté au panier pour ramassage au ${vars[0]}`,
        proceedToBasket: 'Passer au panier',
        viewInBasket: 'Voir dans le panier',
        viewAndCheckout: 'Voir le panier et passer à la caisse',
        viewAndReserve: 'Voir le panier et réserver',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'N’oubliez pas d’utiliser votre carte de crédit Sephora',
        testSeeDetails: 'Voir les détails',
        testCardDiscount: `Save ${vars[0]} off your Sephora order when you open and use your Sephora Credit Card.`,
        testCardDiscountTitle: 'Open a Sephora Credit Card Today'
    };

    return resources[label];
};
